// components/views/claim/TermsAgreement.jsx
import React, { Component } from 'react';

class TermsAgreement extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      termsAccepted: false
    };
  }

  handleTermsChange = (e) => {
    this.setState({ termsAccepted: e.target.checked });
  };

  render() {
    const { jobDetails, onNext, onBack } = this.props;
    const { termsAccepted } = this.state;

    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        {/* Header */}
        <div className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 py-6">
          <div className="max-w-md mx-auto text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white bg-opacity-20 rounded-full mb-3">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </div>
            <h1 className="text-xl font-bold mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
              Platform Agreement
            </h1>
            <p className="text-teal-100" style={{fontFamily: 'Lato, sans-serif'}}>
              Quick review of how Jobvious works
            </p>
          </div>
        </div>

        <div className="px-4 py-6">
          <div className="max-w-md mx-auto">
            
            {/* What You Get */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  What Jobvious Provides
                </h2>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      Guaranteed Payment Processing
                    </div>
                    <div className="text-sm text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                      Secure ${jobDetails?.jobTotal} payment automatically processed upon job completion
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      Complete Job Management
                    </div>
                    <div className="text-sm text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                      Automated invoicing, progress tracking, and dealer communication
                    </div>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-green-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="font-medium text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                      Professional Support
                    </div>
                    <div className="text-sm text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                      Quality assurance and dispute resolution if needed
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Your Commitments */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-800" style={{fontFamily: 'Montserrat, sans-serif'}}>
                  Your Commitments
                </h2>
              </div>
              
              <div className="space-y-4">
                <div className="bg-blue-50 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"/>
                      </svg>
                    </div>
                    <div>
                      <div className="font-medium text-blue-800 mb-1" style={{fontFamily: 'Montserrat, sans-serif'}}>
                        Timeline Commitment
                      </div>
                      <div className="text-sm text-blue-700" style={{fontFamily: 'Lato, sans-serif'}}>
                        Start work within 48 hours and complete professionally according to dealer specifications
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-orange-50 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                      </svg>
                    </div>
                    <div>
                      <div className="font-medium text-orange-800 mb-1" style={{fontFamily: 'Montserrat, sans-serif'}}>
                        Platform-Only Payments
                      </div>
                      <div className="text-sm text-orange-700" style={{fontFamily: 'Lato, sans-serif'}}>
                        All payment processing must go through Jobvious - this protects both you and the dealer
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-purple-50 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <svg className="w-3 h-3 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="font-medium text-purple-800 mb-1" style={{fontFamily: 'Montserrat, sans-serif'}}>
                        Quality Standards
                      </div>
                      <div className="text-sm text-purple-700" style={{fontFamily: 'Lato, sans-serif'}}>
                        Complete work to professional standards with clear communication throughout
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Platform Integrity Notice */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3 h-3 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/>
                  </svg>
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-yellow-800 mb-2" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    Platform Integrity
                  </h4>
                  <div className="text-sm text-yellow-700 space-y-1" style={{fontFamily: 'Lato, sans-serif'}}>
                    <p>To maintain fairness for all specialists, violations of platform terms may result in penalties:</p>
                    <div className="mt-2 text-xs space-y-1">
                      <div>• Not starting within 48 hours: $75</div>
                      <div>• Abandoning work mid-job: $50</div>
                      <div>• Attempting direct payment: $200</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Agreement Checkbox */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <div className="flex items-start space-x-3">
                <input 
                  type="checkbox" 
                  id="termsAcceptance"
                  checked={termsAccepted}
                  onChange={this.handleTermsChange}
                  className="mt-1 w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                />
                <label htmlFor="termsAcceptance" className="flex-1">
                  <div className="font-medium text-gray-800 mb-1" style={{fontFamily: 'Montserrat, sans-serif'}}>
                    I understand and agree to these terms
                  </div>
                  <div className="text-sm text-gray-600" style={{fontFamily: 'Lato, sans-serif'}}>
                    By checking this box, you acknowledge that you have read and agree to work within the Jobvious platform guidelines.
                  </div>
                </label>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex space-x-3 mb-6">
              <button 
                onClick={onBack}
                className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-xl transition-colors"
                style={{fontFamily: 'Montserrat, sans-serif'}}
              >
                <span className="flex items-center justify-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"/>
                  </svg>
                  Back
                </span>
              </button>
              
              <button 
                onClick={onNext}
                disabled={!termsAccepted}
                className={`flex-2 font-bold py-3 px-6 rounded-xl transition-all ${
                  termsAccepted 
                    ? 'bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white shadow-lg' 
                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                }`}
                style={{fontFamily: 'Montserrat, sans-serif', minWidth: '200px'}}
              >
                <span className="flex items-center justify-center">
                  Continue to Registration
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </span>
              </button>
            </div>

            {/* Trust Footer */}
            <div className="text-center pb-6">
              <div className="flex items-center justify-center space-x-2 text-gray-400 text-sm">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"/>
                </svg>
                <span style={{fontFamily: 'Lato, sans-serif'}}>Terms protect both specialists and dealers</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TermsAgreement;